import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneNumberFormatPipe } from './phone-number-format.pipe';

@NgModule({
  declarations: [PhoneNumberFormatPipe],
  imports: [CommonModule],
  providers: [PhoneNumberFormatPipe],
  exports: [PhoneNumberFormatPipe],
})
export class PhoneNumberFormatModule {}
